import React, { useState } from 'react';

import { Box, Button } from '@rbilabs/universal-components';
import AsyncStorage from '@react-native-async-storage/async-storage';

import useEffectOnce from 'hooks/use-effect-once';
import { clearLocaleStorage } from 'utils/intl/locale/clear-locale-storage';
import LocalStorage from 'utils/local-storage';

import { HiddenEnvItem } from './env-item';
import { HiddenSection } from './hidden-section';

const LocalStorageItemsContent = () => {
  const [localStorageData, setLocalStorageData] = useState({});

  useEffectOnce(() => {
    LocalStorage.getAll()
      .then(data => {
        setLocalStorageData(data);
      })
      .catch(() => {
        alert('failed to get local storage data');
      });
  });
  return (
    <>
      <Button size="sm" mb="$4" onPress={clearLocaleStorage}>
        Clear Has Shown Locale Selector Storage
      </Button>
      <Box>
        {Object.entries(localStorageData).map(([key, value]) => (
          <Box key={key} pb="$2">
            <HiddenEnvItem key={key} envKey={key} value={JSON.stringify(value)} />
            <Button size="sm" onPress={() => AsyncStorage.removeItem(key)}>
              Remove
            </Button>
          </Box>
        ))}
      </Box>
    </>
  );
};

export const LocalStorageItems = () => (
  <HiddenSection title="Local Storage Items" content={<LocalStorageItemsContent />} />
);
